import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { UPSERT_ASSET_MK } from '../components/UpsertAssetModal/UpsertAssetModal.meta';
import { queryKeys } from './queryKeys';
import { UpsertPensionDTO } from '../forms/Pension/PensionForm.meta';

export const UPSERT_PENSION_ENDPOINT = '/Consumer/OtherAssetsUpdate/SavePension';

const upsertPension = (body: UpsertPensionDTO): Promise<null> =>
  authFetch(UPSERT_PENSION_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });

interface Params {
  clientId: string;
}

export const useUpsertPensionMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(upsertPension, {
    mutationKey: [UPSERT_ASSET_MK, 'pension'],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
